export { Konva } from "./_CoreInternals.js";
import { Konva } from "./_CoreInternals.js";
export default Konva;
